// Polyfills for Node.js modules in browser
import { Buffer } from "buffer";
import process from "process";

import React from "react";
import { createRoot } from "react-dom/client";
import App from "app/App";

import { ThemeProvider } from "./contexts/ThemeContext";
import { Provider } from "react-redux";

import store from "store";

// Make Buffer and process available globally
(window as any).Buffer = Buffer;
(window as any).process = process;

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </Provider>
  </React.StrictMode>,
);
